import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import axios from "../../axios";
import CustomModal from "../../components/CustomModal";
import Alert from "react-s-alert";
import qs from "qs";
import Cropper from "react-crop";
import "react-crop/cropper.css";
import {ContentState, convertToRaw, EditorState} from "draft-js";
import { FOTO_CONTENT_HOST } from "../../constants/siteConfig";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import DropdownView from "./DropdownView";
import FormDropdown from "../../components/FormDropdown";
import ImageZoom from 'react-medium-image-zoom'
import {Editor} from "react-draft-wysiwyg";

const tipe_soal = [
    { key: "single", value: "Single Option" },
    { key: "essay", value: "Essay" }
];

class Lists extends React.Component {
    constructor() {
        super();
        this.state = {
            mapel_id: "",
			question_text: "",
			question_id: "",
			option_id: "",
			option: [],
			option_text:"",
			detailOption:[],
			dataMapel : [],
			isButtonLoading: false,
			isLoading: false,
			defaultImg: "./noimage.gif",
			showformAdd: false,
			isModalShow: false,
			imageCrop: null,
			image: null,
			previewImg: null,
			mode:null,
			score:false,
			checked: false,
			keterangan: "",
			files: [],
			option_count: "",
			question_type:"",
			option_match_text:"",
			event_foto: "",
			setTags:[],
			editorState: EditorState.createEmpty(),
			showformEdit: false,
			Soalmode:null,
			isModalSoal: false,
			ShowFormSoal: false,
			ShowFormSoalEdit: false,
			tags:[]
		};

		this.toggleModal = this.toggleModal.bind(this);
		this.toggleEditHandler = this.toggleEditHandler.bind(this);
		this.handleChange = this.handleChange.bind(this);
    	this.handleSubmit = this.handleSubmit.bind(this);
    	this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    	this.handleSubmitEdit = this.handleSubmitEdit.bind(this);
		this.handleSubmitEditSoal = this.handleSubmitEditSoal.bind(this);
		this.toggleModalSoal = this.toggleModalSoal.bind(this);
		this.toggleModalSoalEdit = this.toggleModalSoalEdit.bind(this);
		this.addTags = this.addTags.bind(this);
		this.handleChangeMapel = this.handleChangeMapel.bind(this);
		this.removeTags = this.removeTags.bind(this);
		
    }

	handleChangeMapel(event) {
		const target = event.target;
		const value  = target.value;
		const name   = target.name;

		this.setState({
			[name] : value,
		})
	}

	addTags(event){
		let newState = [...this.state.tags];

		if (event.key === "Enter" && event.target.value !== "") {
			this.setState({
				tags: [...this.state.tags, event.target.value],
				keterangan: ''
			});
		}


	};

	removeTags(e){
		var array = [...this.state.tags]; // make a separate copy of the array
		var index = array.indexOf(e)
		if (index !== -1) {
			array.splice(index, 1);
			this.setState({tags: array});
		}
	};

	toggleModalSoal() {
		const isVisible = this.state.ShowFormSoal;
		this.setState({
			option_id: "",
			option_text: "",
			score: "",
			previewImg:"",
			isLoading: false,
			ShowFormSoalEdit: false,
			showformAdd: false,
			showformEdit: false,
			ShowFormSoal: !isVisible
		});
	}

	toggleModalSoalEdit(s) {
		const isVisible = this.state.ShowFormSoalEdit;
		this.setState({
			option_id: "",
			option_text: "",
			score: "",
			previewImg:"",
			ShowFormSoal: false,
			showformAdd: false,
			showformEdit: false,
			ShowFormSoalEdit: !isVisible
		});

		if (!isVisible) {
			this.loadDataForm(s);
		}
	}

	togglePersonHandler(){
		const isVisible = this.state.showformAdd;
		this.setState({
			option_id: "",
			option_text: "",
			score: "",
			previewImg:"",
			ShowFormSoal: false,
			ShowFormSoalEdit: false,
			showformEdit: false,
			showformAdd: !isVisible
		});
	}

	toggleEditHandler(e) {
		const isVisible = this.state.showformEdit;
		this.setState({
			ShowFormSoalEdit: false,
			ShowFormSoal: false,
			showformAdd: false,
			showformEdit: !isVisible,
			option_id : e
		});

		if (!isVisible) {
			this.loadDataDetail(e);
		}
	}

	onEditorStateChange(editorState) {
		this.setState({
			question_text: draftToHtml(convertToRaw(editorState.getCurrentContent())),
			editorState: editorState
		});
	}

	loadDataForm(s) {
		this.setState({ isLoading: true });

		const params = qs.stringify({
			question_id:s
		})

		axios({
			method: "post",
			url: "/soal/edit?" + params
		})

			.then(response => {
				const result = response.data;

				if (result.success) {
					const contentBlock = htmlToDraft(result.data.question_text);

					if (contentBlock) {
						const contentState = ContentState.createFromBlockArray(
							contentBlock.contentBlocks
						);
						const editorState = EditorState.createWithContent(contentState);

						this.setState({
							editorState: editorState
						});
					}

					let newState = {
						question_id: result.data.question_id,
						keterangan: "",
						tags:result.data.keterangan ? result.data.keterangan.split('#') : [],
						question_text: result.data.question_text,
						mapel_id: result.data.mapel.mapel_id,
						question_pict: result.data.question_pict,
						question_type_pict: result.data.question_type_pict,
						question_type: result.data.question_type,
						option_count: result.data.question_type !== 'essay' ? result.data.option.length : "",

						previewImg:
							result.data.question_pict !== ""
								? "data:"+result.data.question_type_pict+";base64," + result.data.question_pict
								: null,
						defaultImg: result.data.question_pict !== "" ? null : "./noimage.gif"

					};
					if (result.data.question_type !== 'essay') {
						if (result.data.question_type !== 'match') {
							newState.option = result.data.option.map(
								(item, i) => ({
									option_id: item.option_id,
									option_text: item.option_text,
									score: item.score,
									option_pict: item.option_pict,
									type_pict: item.type_pict,

									previewImgs:
										item.option_pict !== ""
											? "data:"+item.type_pict+";base64," + item.option_pict
											: null,

								})

							);
						}else{
							newState.option = result.data.option.map(
								(item, i) => ({
									option_id: item.option_id,
									option_text: item.option_text,
									option_match_text: item.option_match_text,
									score: item.score
								})
							);
						}

					}else{
						newState.score=this.state.score
					}

					this.setState(newState);


				} else {
					Alert.error(result.message);
				}

				this.setState({ isLoading: false });
			})
			.catch(error => {
				console.log(error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isLoading: false });
			});
	}

    loadData() {
        this.setState({ isLoading: true });

		if(this.props.modesoal !== "Tambah"){
			const params = qs.stringify({
				question_id:this.props.match.params.question_id
			})

			axios({
				method: "post",
				url: "/soal/detail?" + params
			})
				.then(response => {
					const result = response.data;
					if (result.success) {
						let newState = {
							question_id: result.data.question_id,
							question_text: result.data.question_text,
							mapel_id: result.data.mapel.mapel_id,
							question_pict: result.data.question_pict,
							question_type_pict: result.data.question_type_pict,
							question_type: result.data.question_type,
							option_count: result.data.question_type !== 'essay' ? result.data.option.length : "",

							previewImgs:
								result.data.question_pict ? "data:"+result.data.question_type_pict+";base64," + result.data.question_pict
									: "./noimage.gif",
							defaultImgs: result.data.question_pict !== "" ? null : "./noimage.gif"

						};
						if (result.data.question_type !== 'essay') {
							if (result.data.question_type !== 'match') {
								newState.option = result.data.option.map(
									(item, i) => ({
										option_id: item.option_id,
										option_text: item.option_text,
										score: item.score,
										option_pict: item.option_pict,
										type_pict: item.type_pict,
										previewImgs: item.option_pict ? "data:"+item.type_pict+";base64," + item.option_pict : './noimage.gif',
										defaultImgs: item.option_pict !== "" ? null : "./noimage.gif"

									})

								);
							}else{
								newState.option = result.data.option.map(
									(item, i) => ({
										option_id: item.option_id,
										option_text: item.option_text,
										option_match_text: item.option_match_text,
										score: item.score
									})
								);
							}

						}else{
							newState.score=this.state.score
						}

						this.setState(newState);


					} else {
						Alert.error(result.message);
					}

					this.setState({ isLoading: false });
				})
				.catch(error => {
					console.log(error);
					this.setState({ isLoading: false });
					Alert.error("Gagal terhubung ke server!");
				});
		}
    }

	handleHapusButton(a) {
		this.setState({ isButtonLoading: true });
		const url = '/hapus_jawaban_soal'

		let newState = {
			locale:"id",
			platform:"web",
			option_id:a
		};
		// console.log(newState);
		axios({
			method: "post",
			url: url,
			data: qs.stringify(newState)
		})

		.then(response => {
			const result = response.data;
			
			if (result.success) {
				this.setState({ isButtonLoading: false },()=>{
					Alert.success(result.text);
					window.location.reload();
				});
				
			} else {
				if (Array.isArray(result.text)) {
					result.text.map(item => {
						Alert.error(item);

						return true;
					});
				} else {
					Alert.error(result.text);
				}

				this.setState({ isButtonLoading: false });
			}
		})
		
		.catch(error => {
			console.log(error);
			this.setState({ isButtonLoading: false });
			Alert.error("Gagal terhubung ke server!");
		});

		this.setState({ modalShow: false });
		window.location.reload()
	}

	toggleModal(option_id) {
		this.setState({
			modalShow: !this.state.modalShow,
			option_id : option_id
		});
	}

	loadDataDetail(e) {

        this.setState({ isLoading: true });
            axios({
                method: "post",
                url: '/form_edit_soal',
                data: qs.stringify({ option_id: e})
            })

            .then(response => {
				const result = response.data;
                if (result.success === true) {
					this.setState({
                        detailOption: result.data.option[0],
                        score: result.data.option[0].score,
                        question_id: result.data.question_id,
                        isLoading: false
                    });
					let newState = {
						question_id: result.data.option[0].question_id,
						option_id: result.data.option[0].option_id,
						option_text: result.data.option[0].option_text,
						score: result.data.option[0].score,

						previewImg:
							result.data.option[0].option_pict !== ""
								? "data:"+result.data.option[0].type_pict+";base64," + result.data.option[0].option_pict
								: null,
						defaultImg: result.data.option[0].option_pict !== "" ? null : "./noimage.gif"

					};
					this.setState(newState);
                } else {
                    Alert.error(result.message);
                    this.setState({ isLoading: false });
                }

            })

            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
	}
	
	handleChange(event) {
		const target = event.target;
		const value = target.type === "checkbox" || target.type === "radio"  ? target.checked : target.value;
		
		const name = target.name;

		const newState = {
			[name]: value
		}

		this.setState(newState);
	}

	handleCheckboxChange = event => {
		this.setState({ checked: event.target.checked })
	  }

	handleSubmit() {
		let formData = new FormData();

		const config = {
			headers: { "content-type": "multipart/form-data" }
		};
		
		formData.append("question_id", this.state.question_id);
		formData.append("event_foto", this.state.imageCrop);
		formData.append("option_text", this.state.option_text);
		formData.append("checkbox", this.state.checked);


		const url ='/tambah_jawaban_soal';
		
		this.setState({ isButtonLoading: true });
		axios
			.post(url, formData, config)
			.then(response => {
				const result = response.data;

				if (result.success) {
					this.setState({ isButtonLoading: false },()=>{
						Alert.success(result.message);
						// window.location.reload();
						this.loadData();
						this.setState({ isButtonLoading: false,
							question_id:'',
							event_foto:'',
							option_text:'',
							checkbox:''});
						window.location.reload()
					});
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
							Alert.error(item);
							return true;
						});
					} else {
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log("ERROR", error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isButtonLoading: false });
			});
			this.setState({ showformAdd: false });
	}

	handleSubmitEdit() {
		let formData = new FormData();

		const config = {
			headers: { "content-type": "multipart/form-data" }
		};
		
		formData.append("question_id", this.state.question_id);
		formData.append("option_id", this.state.option_id);
		formData.append("event_foto", this.state.imageCrop);
		formData.append("option_text", this.state.option_text);
		formData.append("checkbox", this.state.checked);


		const url ='/edit_post_jawaban_soal';
		
		this.setState({ isButtonLoading: true });
		axios
			.post(url, formData, config)
			.then(response => {
				const result = response.data;

				if (result.success) {
					this.setState({ isButtonLoading: false },()=>{
						Alert.success(result.message);
						window.location.reload();
					});
					
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
							Alert.error(item);

							return true;
						});
					} else {
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log("ERROR", error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isButtonLoading: false });
			});
			this.setState({ showformAdd: false });
	}

	handleSubmitEditSoal() {
		let formData = new FormData();

		const config = {
			headers: { "content-type": "multipart/form-data" }
		};

		formData.append("question_id", this.state.question_id);
		formData.append("keterangan", this.state.tags.join("#"));
		formData.append("mapel_id", this.state.mapel_id);
		formData.append("question_type", this.state.question_type);
		formData.append("question_text", this.state.question_text);
		formData.append("event_foto", this.state.imageCrop);
		formData.append("user_id", localStorage.SISMART_USER_ID)


		const url = this.state.Soalmode === "tambah" ? "soal/add" : "soal/edit/post";

		this.setState({ isButtonLoading: true });

		axios
			.post(url, formData, config)
			.then(response => {
				const result = response.data;

				if (result.success) {
					Alert.success(result.message);
					this.props.history.replace("/soal/detail/"+ result.data);
					window.location.reload()
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
							Alert.error(item);

							return true;
						});
					} else {
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log("ERROR", error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isButtonLoading: false });
			});
	}

	onChange(evt) {
		this.setState({
			previewImg: null,
			defaultImg: null,
			imageCrop: null,
			image: evt.target.files[0],
			event_foto: ""
		});
	}

	async crop() {
		let image = await this.refs.crop.cropImage();

		this.setState({
			previewImg: window.URL.createObjectURL(image),
			defaultImg: null,
			event_foto: window.URL.createObjectURL(image),
			imageCrop: image
		});
	}

	imageLoaded(img) {
		if (
			img.naturalWidth &&
			img.naturalWidth < 262 &&
			img.naturalHeight &&
			img.naturalHeight < 147
		) {
			this.crop();
		}
	}

	clear() {
		this.refs.file.value = null;
		this.setState({
			previewImg: null,
			defaultImg: "./noimage.gif",
			image: null,
			imageCrop: null,
			event_foto: ""
		});
	}

	loadDataMapel(){
		axios.post("/mapel")
			.then(response => {
				return response.data.data.map(item => ({
					key: item.mapel_id,
					value : item.mapel_nama
				}))
			})
			.then(result => {
				this.setState({
					dataMapel: result
				})
			})
			.catch(error => {
				console.log("Mapel Undefinded")
			})
	}

    componentDidMount() {
        this.loadData();
		this.loadDataMapel();
    }

    render() {
		let FormSoalAdd = null;
		if (this.state.ShowFormSoal) {
			FormSoalAdd = (
				<div className="card" >
					<div className="card-header">{this.props.mode} Pertanyaan</div>
					<div className="card-block">
						{this.state.isLoading ? (
							"Memuat Data..."
						) : (
							<div className="form-horizontal animated fadeIn">
								<div className="form-group row">

									<div className="col-md-12">
										<DropdownView
											handleChange={this.handleChange}
											stateName="question_type"
											label="Type Soal"
											disabled={this.state.Soalmode === 'edit' ? true : false}
											items={[
												{ key: "single", value: "Single Option" },
												{ key: "essay", value: "Essay" }
											]}
											value={this.state.question_type}
										/>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">
												Mata pelajaran
											</label>
											<div className="col-md-10">
												<FormDropdown
													items = {this.state.dataMapel}
													onChange = {this.handleChangeMapel}
													value={this.state.mapel_id.toString()}
													placeholder={"Pilih Mapel"}
													name="mapel_id"
												/>
											</div>
										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">
												Pertanyaan
											</label>
											<div className="col-md-10">
												<Editor
													editorState={this.state.editorState}
													wrapperClassName="demo-wrapper"
													editorClassName="demo-editor"
													name="question_text"
													onEditorStateChange={this.onEditorStateChange.bind(
														this
													)}
													toolbar={{
														options: [
															"inline",
															"blockType",
															"fontSize",
															"fontFamily",
															"list",
															"textAlign",
															"history",
															"link",
															"embedded",
															"emoji"
														]
													}}
												/>

												<div className="col-md-5">
													<label className="btn btn-info" style={{ cursor: "pointer" }}>
														Choose Image ...
														<input
															ref="file"
															type="file"
															onChange={this.onChange.bind(this)}
															hidden
														/>
													</label>{" "}
													&nbsp;
													{this.state.previewImg && (
														<label onClick={this.clear.bind(this)} className="btn btn-danger" style={{ cursor: "pointer" }}>
															Clear
														</label>
													)}
													{this.state.defaultImg && (
														<div>
															<img
																src={this.state.defaultImg}
																className="img-thumbnail"
																style={{ width: "800px", height: "500px" }}
																alt=""
															/>
														</div>
													)}
													{this.state.previewImg && (
														<div>
															<img
																src={this.state.previewImg}
																className="img-thumbnail"
																style={{ width: "800px", height: "500px" }}
																alt=""
															/>
														</div>
													)}
													{this.state.image &&
													!this.state.previewImg && (
														<div>
															<Cropper
																ref="crop"
																image={this.state.image}
																width={800}
																height={700}
																onImageLoaded={this.imageLoaded.bind(this)}
															/>
															<button
																onClick={this.crop.bind(this)}
																className="btn btn-md btn-success"
															>
																Crop
															</button>
															&nbsp;
															<button
																onClick={this.clear.bind(this)}
																className="btn btn-md btn-danger"
															>
																Clear
															</button>
														</div>
													)}
												</div>

											</div>
										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">
												Tags
											</label>
											<div className="col-md-10">
												<input
													label="Tags Soal"
													name="keterangan"
													className="form-control"
													placeholder="Ketik tags/keterangan disini, Pisahkan dengan tanda "
													onChange={this.handleChange}
													onKeyUp={event =>this.addTags(event)}
													value={this.state.keterangan}
													style={{ marginBottom: 10 }}
												/>
												<div>
													{this.state.tags.map((tag, index) => (
														<div key={index} style={{ marginBottom:'5px' }}>
															<button className="btn btn-primary">{ tag }</button>
															{" "}
															<button style={{ border:'0px' }} className="btn-danger" onClick={(e)=>this.removeTags(tag)}><i className="fa fa-trash"></i></button>
														</div>
													))}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
					<div className="card-footer">
						<button
							type="button"
							className="btn btn-md btn-primary"
							disabled={this.state.isButtonLoading && "disabled"}
							onClick={this.handleSubmitEditSoal}
						>
							{this.state.isButtonLoading ? "Loading" : "Simpan"}
						</button>
					</div>
				</div>
			)
		}

		let FormSoalEdit = null;
		if (this.state.ShowFormSoalEdit) {
			FormSoalEdit = (
				<div className="card" >
					<div className="card-header">{this.props.mode} Pertanyaan</div>
					<div className="card-block">
						{this.state.isLoading ? (
							"Memuat Data..."
						) : (
							<div className="form-horizontal animated fadeIn">
								<div className="form-group row">

									<div className="col-md-12">
										<DropdownView
											handleChange={this.handleChange}
											stateName="question_type"
											label="Type Soal"
											disabled={this.state.Soalmode === 'edit' ? true : false}
											items={[
												{ key: "single", value: "Single Option" },
												{ key: "essay", value: "Essay" }
											]}
											value={this.state.question_type}
										/>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">
												Mata pelajaran
											</label>
											<div className="col-md-10">
												<FormDropdown
													items = {this.state.dataMapel}
													onChange = {this.handleChangeMapel}
													value={this.state.mapel_id.toString()}
													placeholder={"Pilih Mapel"}
													name="mapel_id"
												/>
											</div>
										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">
												Pertanyaan
											</label>
											<div className="col-md-10">
												<Editor
													editorState={this.state.editorState}
													wrapperClassName="demo-wrapper"
													editorClassName="demo-editor"
													name="question_text"
													onEditorStateChange={this.onEditorStateChange.bind(
														this
													)}
													toolbar={{
														options: [
															"inline",
															"blockType",
															"fontSize",
															"fontFamily",
															"list",
															"textAlign",
															"history",
															"link",
															"embedded",
															"emoji"
														]
													}}
												/>

												<div className="col-md-5">
													<label className="btn btn-info" style={{ cursor: "pointer" }}>
														Choose Image ...
														<input
															ref="file"
															type="file"
															onChange={this.onChange.bind(this)}
															hidden
														/>
													</label>{" "}
													&nbsp;
													{this.state.previewImg && (
														<label onClick={this.clear.bind(this)} className="btn btn-danger" style={{ cursor: "pointer" }}>
															Clear
														</label>
													)}
													{this.state.defaultImg && (
														<div>
															<img
																src={this.state.defaultImg}
																className="img-thumbnail"
																style={{ width: "800px", height: "500px" }}
																alt=""
															/>
														</div>
													)}
													{this.state.previewImg && (
														<div>
															<img
																src={this.state.previewImg}
																className="img-thumbnail"
																style={{ width: "800px", height: "500px" }}
																alt=""
															/>
														</div>
													)}
													{this.state.image &&
													!this.state.previewImg && (
														<div>
															<Cropper
																ref="crop"
																image={this.state.image}
																width={800}
																height={700}
																onImageLoaded={this.imageLoaded.bind(this)}
															/>
															<button
																onClick={this.crop.bind(this)}
																className="btn btn-md btn-success"
															>
																Crop
															</button>
															&nbsp;
															<button
																onClick={this.clear.bind(this)}
																className="btn btn-md btn-danger"
															>
																Clear
															</button>
														</div>
													)}
												</div>

											</div>
										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">
												Tags
											</label>
											<div className="col-md-10">
												<input
													label="Tags Soal"
													name="keterangan"
													className="form-control"
													placeholder="Ketik tags/keterangan disini, Pisahkan dengan tanda "
													onChange={this.handleChange}
													onKeyUp={event =>this.addTags(event)}
													value={this.state.keterangan}
													style={{ marginBottom: 10 }}
												/>
												<div>
													{this.state.tags.map((tag, index) => (
														<div key={index} style={{ marginBottom:'5px' }}>
															<button className="btn btn-primary">{ tag }</button>
															{" "}
															<button style={{ border:'0px' }} className="btn-danger" onClick={(e)=>this.removeTags(tag)}><i className="fa fa-trash"></i></button>
														</div>
													))}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
					<div className="card-footer">
						<button
							type="button"
							className="btn btn-md btn-primary"
							disabled={this.state.isButtonLoading && "disabled"}
							onClick={this.handleSubmitEditSoal}
						>
							{this.state.isButtonLoading ? "Loading" : "Simpan"}
						</button>
					</div>
				</div>
			)
		}


		let formAdd = null;
    	if (this.state.showformAdd) {
		formAdd = (
			<div className="card-header">
				<div style={{ marginTop: "10px", display: "inline-block" }} >
					Form Jawaban
				</div>
			<hr></hr>
			<div className="card-body">
			
				<div className="form-group row">
				
					<label className="col-md-2 form-control-label"
						style={{
                                marginTop: 25
						}}>
						Jawaban
					</label>
					<div className="col-md-10">
						<input
							type="text"
							name="option_text"
							placeholder="Opsi Jawaban"
							style={{
								padding: "6px 7px",
								border: "1px solid #ccc",
								width: "50%",
                                marginBottom: 15,
                                marginTop: 25
							}}
						value={this.state.option_text}
						onChange={this.handleChange}
						/>
						<input
							type="checkbox"
							style={{
								padding: "3px 7px",
								border: "1px solid #ccc",
								width: "5%"
							}}
							checked={this.state.checked}
							value={this.state.score}
							onChange={this.handleCheckboxChange}
						/>
						&nbsp;
							<label className="btn btn-info" 
								style={{
									cursor: "pointer",
									marginTop:5
								}}>
								Choose Image ...
								<input
									ref="file"
									type="file"
									onChange={this.onChange.bind(this)}
									hidden
								/>
							</label>{" "}
							&nbsp;
							{this.state.previewImg && (
								<label onClick={this.clear.bind(this)} className="btn btn-danger"
									style={{
										cursor: "pointer",
										marginTop:5
									}}>
									Clear
								</label>
							)}
							{this.state.defaultImg && (
								<div>
									<img
										src={this.state.defaultImg}
										className="img-thumbnail"
										style={{ width: "320px", height: "180px" }}
										alt=""
									/>
								</div>
							)}
							{this.state.previewImg && (
								<div>
									<img
										src={this.state.previewImg}
										className="img-thumbnail"
										style={{ width: "320px", height: "180px" }}
										alt=""
									/>
								</div>
							)}
							{this.state.image &&
							!this.state.previewImg && (
								<div>
									<Cropper
										ref="crop"
										image={this.state.image}
										width={600}
										height={400}
										onImageLoaded={this.imageLoaded.bind(this)}
									/>
									<button
										onClick={this.crop.bind(this)}
										className="btn btn-md btn-success"
									>
										Crop
									</button>
									&nbsp;
									<button
										onClick={this.clear.bind(this)}
										className="btn btn-md btn-danger"
									>
										Clear
									</button>
								</div>
							)}
					</div>
					
				</div>

				<hr></hr>
				<button
					className="btn btn-md btn-danger"
					style={{
						marginLeft: 15,
						marginTop:10,
						marginBottom:15
					}}
					disabled={this.state.isButtonLoading && "disabled"}
					onClick={this.handleSubmit}
					>
					{this.state.isButtonLoading ? "Loading" : "Simpan"}
				</button>

			</div>
		</div>
		);
	}

		let formEdit = null;
    	if (this.state.showformEdit) {
			formEdit = (
			<div className="card-header">
				<div style={{ marginTop: "10px", display: "inline-block" }} >
					Form Jawaban
				</div>
				<hr></hr>
				<div className="card-body">
					
					<div className="form-group row">
						<label className="col-md-2 form-control-label"
						style={{
							marginTop: 25
						}}>
							Jawaban
						</label>
							<div className="col-md-10">
								<input
									type="text"
									name="option_text"
									placeholder="Opsi Jawaban"
									style={{
										padding: "3px 7px",
										border: "1px solid #ccc",
										width: "50%",
										marginBottom: 15,
										marginTop: 25
									}}
									value={this.state.option_text}
									onChange={this.handleChange}
								/>
								<input
									type="checkbox"
									style={{
										padding: "3px 7px",
										border: "1px solid #ccc",
										width: "5%"
									}}
									checked={this.state.checked != '' ? 'checked' : ''}
									value={this.state.score}
									onChange={this.handleCheckboxChange}
								/>
								&nbsp;
									<label className="btn btn-info" 
									style={{ 
										cursor: "pointer",
										marginTop:5
										}}>
										Choose Image ...
										<input
											ref="file"
											type="file"
											onChange={this.onChange.bind(this)}
											hidden
										/>
									</label>{" "}
									&nbsp;
									{this.state.previewImg && (
										<label onClick={this.clear.bind(this)} className="btn btn-danger"
											style={{
												cursor: "pointer",
												marginTop:5
											}}>
											Clear
										</label>
									)}
									{this.state.defaultImg && (
										<div>
											<img
												src={this.state.defaultImg}
												className="img-thumbnail"
												style={{ width: "320px", height: "180px" }}
												alt=""
											/>
										</div>
									)}
									{this.state.previewImg && (
										<div>
											<img
												src={this.state.previewImg}
												className="img-thumbnail"
												style={{ width: "320px", height: "180px" }}
												alt=""
											/>
										</div>
									)}
									{this.state.image &&
									!this.state.previewImg && (
										<div>
											<Cropper
												ref="crop"
												image={this.state.image}
												width={600}
												height={400}
												onImageLoaded={this.imageLoaded.bind(this)}
											/>
											<button
												onClick={this.crop.bind(this)}
												className="btn btn-md btn-success"
											>
												Crop
											</button>
											&nbsp;
											<button
												onClick={this.clear.bind(this)}
												className="btn btn-md btn-danger"
											>
												Clear
											</button>
										</div>
									)}
							</div>
						
					</div>

					<hr></hr>
					<button
						className="btn btn-md btn-danger"
						style={{
							marginLeft:5,
							marginTop:10,
							marginBottom:15
						}}
						disabled={this.state.isButtonLoading && "disabled"}
						onClick={this.handleSubmitEdit}
						>
						{this.state.isButtonLoading ? "Loading" : "Simpan"}
					</button>
				</div>
			</div>
			)
	}
	
        return (
			
			<div className="col-sm-12">
				
				<CustomModal
					modalHeaderText="Hapus"
					modalBodyText={"Anda yakin ingin menghapus jawaban "+(this.state.option_text)+" ? "}
					modalSubmitText="Hapus"
					handleSubmit={() => this.handleHapusButton(this.state.option_id)}
					toggleModal={this.toggleModal}
					isShow={this.state.modalShow}
				/>


            	<div className="card">
					<div className="card-header">
                        <div style={{ marginTop: "10px", display: "inline-block" }}>
                            Data Pertanyaan
                        </div>
						{this.state.question_id === null || this.state.question_id === "" ?
							<button
								className="btn btn-primary pull-right"
								style={{ marginTop: "2px" }}
								onClick={() => {
									this.toggleModalSoal();
									this.setState({ Soalmode: "tambah" });
								}}
							>
								Tambah Soal
							</button> :

							<button
								className="btn btn-primary pull-right"
								style={{ marginTop: "2px" }}
								onClick={() => {
									this.toggleModalSoalEdit(this.state.question_id);
									this.setState({ Soalmode: "edit" });
								}}
							>
								Edit Soal
							</button>
						}
                    </div>
					<div className="card-body">
						<table className="table table-striped table-bordered animated fadeIn">
								<tr>
									<td width={100}>Type Soal</td>
									<td>{this.state.question_type}</td>
								</tr>
								<tr>
									<td>Pertanyaan </td>
									<td><div dangerouslySetInnerHTML={{ __html: this.state.question_text }} /></td>
								</tr>
								<tr>
									<td>Gambar</td>
									<td>
										<div>
											<ImageZoom
												image={{
													src: this.state.previewImgs,
													className: 'img',
													style: { width: '20em' }
												}}
												zoomImage={{
													src: this.state.previewImgs,
													alt: 'Golden Gate Bridge'
												}}
											/>
										</div>
									</td>
								</tr>
						</table>                    
                	</div>                
            	</div>

				<div className="card">{FormSoalAdd}{FormSoalEdit}{formAdd}{formEdit}</div>
				{this.state.question_type !== "" && this.state.question_type !=="essay" ?(
					<div className="card">
					<div className="card-header">
                        <div style={{ marginTop: "10px", display: "inline-block" }}>
                            Data Jawaban
                        </div>
						<button
							className="btn btn-primary pull-right"
							style={{ marginTop: "2px" }}
							onClick={() => {
								this.togglePersonHandler();
								this.setState({ mode: "tambah" });
							}}
						>
							Tambah Jawaban
						</button>
                    </div>
					<div className="card-body">
						<table className="table table-striped table-bordered animated fadeIn">
							<thead>
								<tr>
									<th width="150">Jawaban</th>
									<th>Gambar</th>
									<th width="150">Jawaban Benar</th>
									<th width="150">Opsi</th>
								</tr>
							</thead>

							<tbody>				
								{this.state.option.map(item => {
									return (
										<tr key={item.option_id}>
											<td><div dangerouslySetInnerHTML={{ __html: item.option_text }} /></td>
											<td>
												{item.option_pict ? (
													// <img
													// src={"data:"+item.qtype_pict+";base64,"+item.option_pict}
													// 	className="img-thumbnail"
													// 	style={{ width: "100px" }}
													// 	alt=""
													// />
													<ImageZoom
														image={{
															src: "data:"+item.qtype_pict+";base64,"+item.option_pict,
															className: 'img',
															style: { width: '20em' }
														}}
													/>
												):(
													<ImageZoom
														image={{
															src: "./noimage.gif",
															className: 'img',
															style: { width: '10em' }
														}}
													/>
												)
												}
												
											</td>
											<td>{item.score}</td>
											<td>
												
												<button
													className="btn btn-primary btn-sm"
													type="button"
													onClick={() => {
														this.setState({ option_texts: item.option_text });
														this.toggleEditHandler(item.option_id);
													}}
													>
													Edit
												</button>
												&nbsp;&nbsp;
												<button
													type="button"
													className="btn btn-danger btn-sm"
													onClick={() => {
														this.toggleModal();
														this.setState({ option_id: item.option_id,
															option_text:item.option_text,
															type_pict:item.type_pict,
															option_pict:item.option_pict });
													}} >
														Hapus
												</button>
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>                    
                	</div>
            	</div>
				):""}
            	
			</div>
        );
    }
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/Soal/Detail_soal.js